import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Tokens } from "../model/auth.model";
import { toBodyParams, toQueryParams } from "../utils/http.util";
import { PublicConfigService } from "./public.config.service";
import { StorageService } from "./storage.service";

@Injectable({
  providedIn: 'root'
})
export class EvaluationOverviewService {

  constructor(private httpClient: HttpClient, private publicConfigService: PublicConfigService, private storage: StorageService) {

  }

  GetEvaluationOverviewList(stageId: string, filters: any) {
    return this.httpClient.post(`${this.publicConfigService.rpBaseUrl}/api/judging/${stageId}`, toBodyParams(filters));
  }

  GetEvaluationOverviewDetailsList(judgeId: string, filters: any) {
    return this.httpClient.post(`${this.publicConfigService.rpBaseUrl}/api/judging/judge-details/${judgeId}`, toBodyParams(filters));
  }

  ExportEvaluationOverviewList(stageId: string, filters: any) {
    return this.httpClient.post(`${this.publicConfigService.rpBaseUrl}/api/judging/export/${stageId}`, toBodyParams({ ...filters }), {
      responseType: 'blob',
      observe: 'response'
    });
  }

  ExportData(stageId: string, InternalExport = true, ExportFormat: 'xlsx' | 'csv' = 'xlsx') {
    return this.httpClient.get(`${this.publicConfigService.rpBaseUrl}/api/judging/export-all-data/${stageId}`, {
      params: toQueryParams({ stageId, InternalExport, ExportFormat  }),
      responseType: 'blob',
      observe: 'response'
    });
  }

  ExportEvaluationOverviewDetailsList(judgeId: string, filters: any) {
    return this.httpClient.post(`${this.publicConfigService.rpBaseUrl}/api/judging/judge-details/${judgeId}/export`,toBodyParams({ ...filters }), {
      responseType: 'blob',
      observe: 'response'
    });
  }

  updateEvaluationOverviewListUser(stageUserId: string, body: any) {
    return this.httpClient.put(`${this.publicConfigService.rpBaseUrl}/api/judging/${stageUserId}?loader=false`, body, {

    });
  }

  GetEvaluationAvailableJudges(judgementId: string, filters: any) {
    return this.httpClient.get(`${this.publicConfigService.rpBaseUrl}/api/judging/available-judges/${judgementId}`, {

      params: toQueryParams({ ...filters })
    });
  }

  reassignJudge(judgementId: string, toJudgeId: string) {
    return this.httpClient.put(`${this.publicConfigService.rpBaseUrl}/api/judging/reassign`, { judgementId, toJudgeId }, {

    });
  }

}
